// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__gA4ON","left_sec":"Logo_left_sec__sr9Tt"};